import { render, staticRenderFns } from "./bureauStatisticsDetail.vue?vue&type=template&id=10e4179d&"
import script from "./bureauStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./bureauStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./bureauStatisticsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports